import React, { Fragment, useEffect, useRef, useState } from "react";
import Button from "../../Component/Button/Button";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./DiscountCode.module.css";
import { DiscountCodeApi } from "../../Api/ClientServices";
import { errorToast } from "../../Toast/Toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { getUserInfo } from "../../Api/BarestServices";

const DiscountCode = (props) => {
  const [show, setShow] = useState(false);
  const [code, setCode] = useState();
  const [score, setScore] = useState();
  const [disable, setDisable] = useState();
  useEffect(() => {
    getScore();
  }, []);
  const getScore = async () => {
    getUserInfo((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setScore(res.info.score);
        }
      }else{
        console.error(res)
      }
    })
  };
  const onClickHandler = () => {
    setShow(true);
    const codeId = {
      id: props.location.state,
    };
    DiscountCodeApi(codeId, (suc, res) => {
      if (res.status === 0) {
        errorToast(res.message);
        setDisable(false);
      } else {
        setCode(res.code);
        setDisable(false);
      }
    });
  };
  const [copySuccess] = useState("");
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
  }
  return (
    <Fragment>
      <BurgerMenuTitle title={"کد تخفیف"} />

      <div className={Style.divHolder}>
        <div className={Style.picHolder}>
          <img src={"/Assets/Images/discount/discount.jpg"} alt="کدتخفیف" />
        </div>
        <div className={Style.underVector}>
          <div className={Style.score}>
            <span> {score}</span>
            <h2> : امتیاز شما</h2>
          </div>
          <div className={Style.discountPart}>
            <div className={Style.btnHolder}>
              {/* <Button
                ClickHandler={onClickHandler}
                Value={"دریافت کد تخفیف"}
                ClassBtn={"confrimBtn"}
                disabledprops={disable}
              /> */}
            </div>
            <div className={show ? Style.code : Style.show}>
              {document.queryCommandSupported("copy") && (
                <div>
                  <button onClick={copyToClipboard} className={Style.copyBtn}>
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                  {copySuccess}
                </div>
              )}
              <form>
                <textarea
                  className={Style.input}
                  value={code}
                  ref={textAreaRef}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default DiscountCode;
